export default "__VITE_PUBLIC_ASSET__2e303ca5__"